var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, Button, Collapse, Grid, InputAdornment, TextField, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { Mail, User } from "react-feather";
import InputMask from "react-input-mask";
import { Translate as T } from "react-localize-redux";
import { ExpDate, Lock } from "../../assets/logos";
import BrandIcon from "../commons/BrandIcon/BrandIcon";
import TermsConditions from "../commons/TermsConditions/TermsConditions";
import { WebPay } from "../../assets/logos";
import { useCardSubscriptionDynamicCheckoutState } from "./state/useCardSubscriptionDynamicCheckoutState";
import KPayCheck from "../commons/KPayCheck/KPayCheck";
import { CardTypeEnum } from "../../shared/constants/CardsEnum";
import { useCheckoutContext } from "../../context/useCheckoutContext";
export var useStyles = makeStyles(function (theme) { return ({
    buttonStyle: {
        "&:hover": {
            backgroundColor: "#023365",
        },
        backgroundColor: "#023365",
        borderRadius: 8,
        color: "#FFF",
        height: "48px",
    },
    centerStyle: {
        textAlign: "center",
    },
    textFieldStyle: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 8,
        },
    },
    webpay: {
        height: theme.spacing(4.5),
        width: theme.spacing(12),
    },
}); });
export var CheckoutCardSubscriptionDynamic = function () {
    var classes = useStyles();
    var _a = useState(false), openTerms = _a[0], setOpenTerms = _a[1];
    var _b = useCardSubscriptionDynamicCheckoutState(), form = _b.form, handler = _b.handler, cardBrand = _b.cardBrand, isValidDate = _b.isValidDate, cardType = _b.cardType, kpayEnable = _b.kpayEnable;
    var _c = useCheckoutContext(), emailKpay = _c.emailKpay, enableKpay = _c.enableKpay;
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: form.handleSubmit(handler.handleSubmit) },
            React.createElement(T, null, function (_a) {
                var translate = _a.translate;
                var _b;
                return (React.createElement(Grid, { container: true, direction: "row", spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, className: classes.centerStyle },
                        React.createElement(WebPay, { className: classes.webpay })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { fullWidth: true, name: "name", variant: "outlined", placeholder: translate("cardCheckout.nameLastname"), className: classes.textFieldStyle, inputRef: form.register({
                                required: {
                                    message: translate("form.fieldRequired"),
                                    value: true,
                                },
                            }), error: !!form.errors["name"], InputProps: {
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(User, { color: "#6D7781", size: 18 }))),
                            }, helperText: !!form.errors["name"] && form.errors["name"].message })),
                    !emailKpay && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(TextField, { fullWidth: true, name: "email", variant: "outlined", placeholder: translate("cardSubscriptionAsync.email"), className: classes.textFieldStyle, inputRef: form.register({
                                pattern: {
                                    message: (React.createElement(T, { id: "form.emailInvalid" })),
                                    value: new RegExp("^[\\w-.]+@([\\w-]+\\.)+[\\w-]+$"),
                                },
                                required: {
                                    message: translate("form.fieldRequired"),
                                    value: true,
                                },
                            }), error: !!form.errors.email, InputProps: {
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(Mail, { color: "#6D7781", size: 18 }))),
                            }, helperText: !!form.errors["email"] && ((_b = form.errors["email"]) === null || _b === void 0 ? void 0 : _b.message) }))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(InputMask, { onChange: function (e) {
                                return e.target.value.replace(/ /g, "").length > 8 ||
                                    e.target.value.replace(/ /g, "").length === 0
                                    ? handler.handleSetFields()
                                    : null;
                            }, mask: "9999 9999 9999 9999 99", maskChar: null }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, "aria-current": true, name: "cardNumber", variant: "outlined", placeholder: translate("cardCheckout.cardNumber"), className: classes.textFieldStyle, inputRef: form.register({
                                minLength: {
                                    message: translate("form.numberCardInvalid"),
                                    value: 16,
                                },
                                required: {
                                    message: translate("form.fieldRequired"),
                                    value: true,
                                },
                            }), error: !!form.errors.cardNumber, InputProps: {
                                startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                    React.createElement(BrandIcon, { image: cardBrand }))),
                            }, helperText: !!form.errors["cardNumber"] &&
                                form.errors["cardNumber"].message }))); })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Box, { display: "flex" },
                            React.createElement(InputMask, { mask: "99/99", maskChar: null }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, placeholder: "MM/AA", variant: "outlined", className: classes.textFieldStyle, error: !!form.errors["expDate"], helperText: !!form.errors["expDate"] &&
                                    form.errors["expDate"].message, name: "expDate", InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(ExpDate, null))),
                                }, inputRef: form.register({
                                    pattern: {
                                        message: (React.createElement(T, { id: "form.expirationDateInvalid" })),
                                        value: new RegExp("^(0[1-9]|1[0-2])\\/?([0-9]{2})$"),
                                    },
                                    required: {
                                        message: translate("form.fieldRequired"),
                                        value: true,
                                    },
                                    validate: isValidDate,
                                }), style: { paddingRight: "12px" } }))); }),
                            React.createElement(InputMask, { mask: "9999", maskChar: null }, function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { name: "cvc", fullWidth: true, type: "password", variant: "outlined", placeholder: "CVC", className: classes.textFieldStyle, error: !!form.errors["cvc"], InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(Lock, null))),
                                }, helperText: !!form.errors["cvc"] && form.errors["cvc"].message, inputRef: form.register({
                                    required: {
                                        message: translate("form.fieldRequired"),
                                        value: true,
                                    },
                                    minLength: {
                                        message: (React.createElement(T, { id: "form.cvcInvalid" })),
                                        value: 3,
                                    },
                                }) }))); }))),
                    React.createElement(Grid, { item: true, xs: 12, style: { marginBottom: "0px !important" } },
                        React.createElement(TermsConditions, { open: openTerms, setOpenTerms: setOpenTerms, form: form })),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Button, { variant: "outlined", color: "primary", className: classes.buttonStyle, disableElevation: true, fullWidth: true, type: "submit" },
                            React.createElement(T, { id: "subscriptionButton" }))),
                    enableKpay && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Collapse, { in: cardType === CardTypeEnum.CREDIT },
                            React.createElement(Box, { pt: 1 },
                                React.createElement(KPayCheck, { handlerChange: handler.handleSetKpayEnable, isChecked: kpayEnable })))))));
            }))));
};
